import { TFunction } from 'i18next';
import { useMemo } from 'react';

import { PaymentMethodEnum } from '@/__generated_graphql__/graphql';
import * as S from '@/components/AdvertisePayments/components/ExtraContent/ExtraContent.styles';
import {
  PaymentOption,
  ViewMethod
} from '@/components/AdvertisePayments/components/ExtraContent/ExtraContent.types';
import { PAYMENT_OPTIONS } from '@/constants/common';

import { XPayIcon } from '../components/ExtraContent/XPayIcon';

export type UsePaymentOptionsProps = {
  methods: ViewMethod[];
  isMobile: boolean;
  t: TFunction;
};

export const usePaymentOptions = ({
  methods,
  isMobile,
  t
}: UsePaymentOptionsProps) => {
  return useMemo(() => {
    const currentOptions: PaymentOption[] = [];
    const hasCard = methods.some(method =>
      ['yigim', 'azericard'].includes(method.id.toLowerCase())
    );

    if (hasCard) {
      const yigimPaymentMethod = methods.find(
        method => method.id.toLowerCase() === 'yigim'
      );

      const isAppleGooglePayEnabled =
        !!yigimPaymentMethod?.isAppleGooglePayEnabled;
      currentOptions.push({
        key: PAYMENT_OPTIONS.CARD,
        label: t('Advertise.payment_bank_card'),
        extra: isMobile ? (
          <S.MobilePaymentLabelGroup>
            {isAppleGooglePayEnabled && (
              <>
                <S.MobilePaymentSeparator />
                <XPayIcon />
              </>
            )}
          </S.MobilePaymentLabelGroup>
        ) : undefined
      });
    }

    const wallet = methods.find(
      method => method.id === PaymentMethodEnum.Wallet
    );
    const hasBalance = !!wallet;

    if (hasBalance) {
      currentOptions.push({
        key: PAYMENT_OPTIONS.WALLET,
        label: `${t('Advertise.payment_personal_account')} (${wallet?.balance ?? 0} ₼)`
      });
    }

    if (methods.some(method => method.id.toLowerCase() === 'portmanat')) {
      currentOptions.push({
        key: PAYMENT_OPTIONS.PORTMANAT,
        label: t('Advertise.payment_portmanat')
      });
    }

    return currentOptions;
  }, [t, methods, isMobile]);
};
